<template>
  <div v-if="!disabled" class="input-discount-percent">
    <label class="input-discount-percent__label">
      <span v-if="title">{{ title }}</span>
      <input
        class="input-discount-percent__input"
        v-bind:class="`input-discount-percent__input--${size}`"
        type="text"
        inputmode="numeric"
        aria-label="Поле ввода скидки в процентах"
        maxlength="3"
        v-bind:disabled="disabled"
        v-bind:value="inputValue"
        v-on:input="onInput"
        v-on:blur="onBlur"
      />
    </label>
    <p
      v-for="(error, index) in violations"
      v-bind:key="index"
      role="alert"
      class="input-discount-percent__violations">{{ error }}
    </p>
  </div>
  <span v-else>{{ inputValue }}</span>
</template>

<script>

/**
 * @description Название события вода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса.
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * @description Поле ввода скидки в процентах.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Значение поля.
     * @returns {string}
     */
    inputValue() {
      return this.value;
    },
  },
  methods: {
    /**
     * @description Отправить событие ввода.
     * @param {number} value
     * @param {boolean} isInvalid
     * @returns {void}
     */
    emitInput(value, isInvalid) {
      this.$emit(NAME_EVENT_INPUT, value);
      if (isInvalid) {
        this.$forceUpdate();
      }
    },
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      this.$emit(NAME_EVENT_BLUR);
    },
    /**
     * @description Обработать ввод.
     * @returns {void}
     */
    onInput(event) {
      const regexp = /\D+/g;
      const inputValue = event.target.value;
      const isInvalid = regexp.test(inputValue);
      const value = isInvalid ? inputValue.replace(regexp, '') : inputValue;
      if (value === '') {
        this.emitInput(0, isInvalid);
        return;
      }
      const percent = Number(value);
      if (percent > 100) {
        this.$forceUpdate();
        return;
      }
      this.emitInput(percent, isInvalid);
    },
  },
  name: 'InputDiscountInPercent',
  props: {
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { default: '', type: String },
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Размер поля (large|small).
     * @type {string}
     */
    size: { default: () => 'large', type: String },
    /**
     * @description Значение в процентах.
     * @type {number}
     */
    value: { type: Number, required: true },
    /**
     * @description Нарушения ограничений.
     * @type {array}
     */
    violations: { default: () => [], type: Array },
  },
};
</script>

<style lang="scss" scoped>
.input-discount-percent {
  display: inline-grid;
  width: min(100%, 152px);
  min-width: 100px;
  height: fit-content;
  &__label {
    display: grid;
    row-gap: 2px;
    > span {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: var(--unfocus-color);
    }
  }
  &__input {
    width: 100%;
    background: no-repeat #ffffff;
    background-image: url("@/assets/img/switch/percent-grey.svg");
    border-radius: var(--input-border-radius);
    border: 1px solid var(--border-color);
    &:focus-visible {
      outline-color: var(--action-color);
    }
    &--large {
      height: 40px;
      padding: 10px;
      padding-right: 32px;
      font-size: 16px;
      background-position: right 10px center;
      background-size: 18px 18px;
    }
    &--small {
      max-width: 75px;
      height: auto;
      padding: 5px 8px;
      padding-right: 30px;
      font-size: 14px;
      background-position: right 8px center;
      background-size: 16px 16px;
      border: 1px solid #0489e0;
    }
  }
  &__violations {
    padding: 0.125rem;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: var(--warning-color);
  }
}
</style>
